export enum CognitoProvider {
	None = "None",
	Google = "Google",
}
